class PagingDisplayController {
    static $inject = [];

    constructor() {
    }

    $onInit() {
    }

    minItemNumber = () => (this.pagingInfo.number - 1) * this.pagingInfo.size + 1;
    maxItemNumber = () => (this.pagingInfo.number - 1) * this.pagingInfo.size + this.items.length;
}

angular
    .module("app")
    .component("pagingDisplay", { // paging-display
        bindings: {
            items: "<",
            pagingInfo: "<",
            onPrev: "&",
            onNext: "&"
        },
        templateUrl: "src/app/_shared/pagingDisplay/pagingDisplay.html",
        controller: PagingDisplayController
    });
